import { render, staticRenderFns } from "./OperationView.vue?vue&type=template&id=5236204a"
import script from "./OperationView.vue?vue&type=script&lang=js"
export * from "./OperationView.vue?vue&type=script&lang=js"
import style0 from "./OperationView.vue?vue&type=style&index=0&id=5236204a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports